import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './FaceScanPrep.css';
import {
  ArrowForwardRounded,
  PersonOutlined,
  VisibilityOutlined,
  WbSunnyOutlined
} from '@mui/icons-material';
import {
  BackButton,
  EnterpriseButton,
  EnterpriseCard,
  EnterpriseGrid,
  EnterpriseHero,
  EnterpriseShell,
  EnterpriseTopBar,
  WarningBanner
} from './ui/EnterpriseLayout';

function FaceScanPrep() {
  const navigate = useNavigate();
  const [showWarning, setShowWarning] = useState(true);
  const [timeRemaining, setTimeRemaining] = useState(10);

  useEffect(() => {
    if (!showWarning) return;
    
    const interval = setInterval(() => {
      setTimeRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 60000);

    return () => clearInterval(interval);
  }, [showWarning]);

  return (
    <EnterpriseShell>
      <EnterpriseTopBar
        right={
          <>
            <BackButton onClick={() => navigate(-1)} />
            <span className="vt-chip vt-chip--subtle">ID verification</span>
          </>
        }
      />

      <EnterpriseHero
        kicker="Face scan"
        meta="Step 2 of 2"
        title="Get ready to scan your face"
        subtitle="A few quick setup tips to ensure the scan completes smoothly."
      />

      <EnterpriseGrid>
        <EnterpriseCard>
          {showWarning && (
            <div style={{ marginBottom: 14 }}>
              <WarningBanner onClose={() => setShowWarning(false)}>
                For security reasons this session will expire in {timeRemaining} minutes.
              </WarningBanner>
            </div>
          )}

          <ul className="vt-list">
            <li className="vt-listItem">
              <WbSunnyOutlined className="vt-listIcon" />
              <span>Find an area with good lighting</span>
            </li>
            <li className="vt-listItem">
              <PersonOutlined className="vt-listIcon" />
              <span>Your upper body and background may be visible</span>
            </li>
            <li className="vt-listItem">
              <VisibilityOutlined className="vt-listIcon" />
              <span>Keep your camera at eye level</span>
            </li>
          </ul>

          <div className="vt-actions">
            <EnterpriseButton variant="primary" onClick={() => navigate('/face-capture')}>
              <span>Continue</span>
              <ArrowForwardRounded className="vt-btnIcon" />
            </EnterpriseButton>
            <EnterpriseButton variant="secondary" type="button" onClick={() => navigate('/')}>
              Back to options
            </EnterpriseButton>
          </div>
        </EnterpriseCard>

        <EnterpriseCard>
          <div className="illustration-container">
            <div className="computer-illustration">
              <div className="monitor">
                <div className="monitor-screen">
                  <div className="face-display">
                    <div className="face-circle">
                      <div className="face-features">
                        <div className="eye left-eye"></div>
                        <div className="eye right-eye"></div>
                        <div className="nose"></div>
                        <div className="mouth"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="webcam">
                  <div className="webcam-lens"></div>
                </div>
              </div>
              <div className="person-back">
                <div className="person-head"></div>
                <div className="person-body"></div>
              </div>
              <div className="view-lines">
                <div className="view-line line-1"></div>
                <div className="view-line line-2"></div>
              </div>
            </div>
          </div>
        </EnterpriseCard>
      </EnterpriseGrid>
    </EnterpriseShell>
  );
}

export default FaceScanPrep;
